__turbopack_context__.v({
  "button": "Button-module__3dJGfa__button",
  "danger": "Button-module__3dJGfa__danger",
  "fullWidth": "Button-module__3dJGfa__fullWidth",
  "ghost": "Button-module__3dJGfa__ghost",
  "primary": "Button-module__3dJGfa__primary",
  "secondary": "Button-module__3dJGfa__secondary",
});
